module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "live-run__content only-flex"
  }, [_c('race-header'), _vm._v(" "), _c('runners-resume'), _vm._v(" "), _c('trainer-notes')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-204adcfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/RaceResume.vue
// module id = 1639
// module chunks = 2